import Alert from "bootstrap/js/dist/alert";

const alertBanner = document.querySelector('.alert-banner');

if (alertBanner) {
  const ctaButton = alertBanner.querySelector('.alert-banner-btn');
  const setCookie = function () {
    document.cookie = "alert_banner_dismissed=1; path=/; max-age=86400";
  }

  alertBanner.addEventListener('closed.bs.alert', setCookie);

  if (ctaButton) {
    ctaButton.addEventListener('click', setCookie);
  }
}
